
import { Link } from 'react-router-dom';

export default function DealershipSupport() {
  const supportServices = [
    {
      category: 'Marketing & Advertising',
      icon: 'ri-megaphone-line',
      services: [
        'Professional website development',
        'Social media campaign templates',
        'Print advertising materials',
        'Digital marketing strategies',
        'Brand guidelines and assets',
        'SEO optimization support'
      ]
    },
    {
      category: 'Technical Support',
      icon: 'ri-tools-line',
      services: [
        '24/7 technical helpdesk',
        'POS system maintenance',
        'Software updates and upgrades',
        'Installation guidance',
        'Troubleshooting assistance',
        'Remote system diagnostics'
      ]
    },
    {
      category: 'Business Development',
      icon: 'ri-line-chart-line',
      services: [
        'Sales training programs',
        'Customer service protocols',
        'Business planning assistance',
        'Market analysis reports',
        'Performance optimization',
        'Growth strategy consulting'
      ]
    },
    {
      category: 'Product & Inventory',
      icon: 'ri-box-3-line',
      services: [
        'Inventory management system',
        'Product training materials',
        'New product introductions',
        'Quality assurance support',
        'Warranty administration',
        'Supply chain coordination'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Comprehensive Support System</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our dedicated support team provides everything you need to succeed. From marketing to technical support, 
            we're with you every step of the way.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {supportServices.map((category, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-emerald-600 rounded-lg flex items-center justify-center mr-4">
                  <i className={`${category.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">{category.category}</h3>
              </div>
              
              <ul className="space-y-3">
                {category.services.map((service, serviceIndex) => (
                  <li key={serviceIndex} className="flex items-start">
                    <i className="ri-check-line text-emerald-600 mr-3 mt-0.5"></i>
                    <span className="text-gray-600">{service}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-lg p-8 text-white">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold mb-4">Dedicated Account Management</h3>
                <p className="text-emerald-100 mb-6">
                  Every dealer gets a dedicated account manager who understands your market and business goals. 
                  Regular check-ins, performance reviews, and strategic planning sessions ensure your success.
                </p>
                <div className="flex items-center space-x-6">
                  <div className="text-center">
                    <div className="text-2xl font-bold">24/7</div>
                    <div className="text-emerald-200 text-sm">Support Available</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold">&lt;2hr</div>
                    <div className="text-emerald-200 text-sm">Response Time</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold">100%</div>
                    <div className="text-emerald-200 text-sm">Satisfaction Rate</div>
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <i className="ri-phone-line text-2xl mb-2"></i>
                  <div className="font-semibold">Phone Support</div>
                  <div className="text-emerald-200 text-sm">Direct hotline access</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <i className="ri-chat-3-line text-2xl mb-2"></i>
                  <div className="font-semibold">Live Chat</div>
                  <div className="text-emerald-200 text-sm">Instant messaging</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <i className="ri-mail-line text-2xl mb-2"></i>
                  <div className="font-semibold">Email Support</div>
                  <div className="text-emerald-200 text-sm">Detailed assistance</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <i className="ri-video-chat-line text-2xl mb-2"></i>
                  <div className="font-semibold">Video Calls</div>
                  <div className="text-emerald-200 text-sm">Face-to-face support</div>
                </div>
              </div>

              <div className="text-center">
                <Link
                  to="/consultation-scheduling"
                  className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Schedule a Consultation
                </Link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
